import { createContext, type ReactNode, useContext, useMemo } from 'react';

export type EmbedViewMode = {
  isEmbed: boolean;
};

const defaultEmbedViewMode: EmbedViewMode = {
  isEmbed: false,
};

const EmbedViewModeContext = createContext<EmbedViewMode>(defaultEmbedViewMode);

export function EmbedViewModeProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: EmbedViewMode;
}) {
  const mode = useMemo(() => value, [value]);

  return (
    <EmbedViewModeContext.Provider value={mode}>
      {children}
    </EmbedViewModeContext.Provider>
  );
}

export function useEmbedViewMode() {
  return useContext(EmbedViewModeContext);
}
